
import React, { useMemo } from 'react';
import { Line } from '@ant-design/plots';

const AvatarCustomTimeseries = ({
  data,
  theme = 'classicDark',
  chartHeight = 380,
}) => {
  
  const chartData = useMemo(() => {
    if (!Array.isArray(data)) return [];
    const rows = [];
    for (const d of data) {
      const date = d.eventDate;
      const avatar = Number(d.avatarCount) || 0;
      const custom = Number(d.customCount) || 0;
      rows.push({ date, category: 'Avatars', value: avatar });
      rows.push({ date, category: 'Custom',  value: custom  });
    }
    return rows;
  }, [data]);

  const config = {
    theme,
    data: chartData,
    height: chartHeight,
    xField: 'date',
    yField: 'value',
    seriesField: 'category',
    colorField: 'category',
    color: ({ category }) => (category === 'Avatars' ? '#3f7cff' : '#5aa65a'),
    axis: {
      x: {
        title: false,
        tickCount: 8,
        labelAutoHide: true,
        labelAutoRotate: true,
        titleStyle: { fill: '#fff' },
        labelStyle: { fill: '#fff' },
      },
      y: {
        title: 'Total Avatars',
        tickCount: 6,
        grid: true,
        titleStyle: { fill: '#fff' },
        labelStyle: { fill: '#fff' },
      },
    },
    legend: {
      color: {
        position: 'bottom',
        layout: { justifyContent: 'center' },
        maxRow: 1,
        title: false,
        itemName: { style: { fill: '#fff', fontSize: 12 } },
      },
    },
    line: { style: { lineWidth: 2 } },
    point: { shape: 'circle', size: 2 },
    tooltip: {
      showTitle: true,
      title: 'Hour: ${hour}:00',
      items: [
        { field: 'value', name: '' },
      
      ],
      formatter: (datum) => {
        return {
          name: datum.category,
          value: `${datum.value} users`,
        };
      },
    },
    interactions: [
      { type: 'legend-highlight' },
      { type: 'tooltip' }
    ],
  };

  return <Line {...config} />;
};

export default AvatarCustomTimeseries;
